<svg xmlns="http://www.w3.org/2000/svg"
     class="board"
     [attr.viewBox]="viewBoxString()"
     preserveAspectRatio="xMidYMid meet">

    @for (line of displayedState.board; track $index; let y = $index) {
        <g>
            @for (square of line; track $index; let x = $index) {
                <g>
                    <g id="square-{{ x }}-{{ y }}"
                       [attr.transform]="getSVGTranslation(SPACE_SIZE * x, SPACE_SIZE * y)"
                       (click)="selectCoord(x, y)">
                        @if (square.isUnreachable() === false) {
                            <rect class="base data-lodestone-square"
                                  [ngClass]="getSquareClasses(x, y)"
                                  [attr.x]="0"
                                  [attr.y]="0"
                                  [attr.width]="SPACE_SIZE"
                                  [attr.height]="SPACE_SIZE"/>
                        }
                        @if (square.isUnreachable()) {
                            <g id="square-{{ x }}-{{ y }}-crumbled">
                                <polygon id="square-{{ x }}-{{ y }}-crumbled-left"
                                         points="0,0     42,0    17,25    67,75    42,100   0,100   0,0"
                                         [ngClass]="getSquareClasses(x, y)"
                                         class="base"/>
                                <polygon id="square-{{ x }}-{{ y }}-crumbled-right"
                                         points="100,0   58,0    35,25    85,75    58,100 100,100 100,0"
                                         [ngClass]="getSquareClasses(x, y)"
                                         class="base"/>
                            </g>
                        }
                        @if (getLodestoneInfo(x, y).isPresent()) {
                            <g id="lodestone-{{ x }}-{{ y }}"
                               [attr.class]="square.isUnreachable() ? 'semi-transparent' : ''"
                               app-lodestone-lodestone
                               [lodestoneInfo]="getLodestoneInfo(x, y).get()"/>
                        } @else {
                            @if (hasPieceToDraw(x, y)) {
                                <circle id="piece-{{ x }}-{{ y }}"
                                        class="base"
                                        [ngClass]="getPieceClasses(x, y)"
                                        [attr.r]="PIECE_RADIUS"
                                        [attr.cx]="SPACE_SIZE / 2"
                                        [attr.cy]="SPACE_SIZE / 2"/>
                            }
                        }
                    </g>
                </g>
            }
        </g>
    }

    @for (capture of viewInfo.capturesToPlace; track $index; let x = $index) {
        <g id="capture-{{ x }}"
           [attr.transform]="getCaptureTransform(x)">
            <circle class="base"
                    [ngClass]="capture.pieceClasses"
                    [attr.r]="PIECE_RADIUS"
                    cx="0"
                    cy="0"/>
        </g>
    }

    @if (interactive()) {
        <g id="available-lodestones">
            @for (lodestone of viewInfo.availableLodestones; track $index; let x = $index) {
                <g id="lodestone-{{ lodestone.direction }}-{{ lodestone.orientation }}-{{ lodestone.owner.toString() }}"
                   [attr.transform]="getAvailableLodestoneTransform(x)"
                   (click)="selectLodestone(lodestone)"
                   app-lodestone-lodestone
                   [lodestoneInfo]="lodestone"/>
            }
        </g>
    }

    @for (groupInfo of viewInfo.pressurePlateGroupInfos; track $index) {
        <g>
            @for (plate of groupInfo.plateInfos; track $index) {
                <g>
                    @for (square of plate.coords; track $index; let pieceIndex = $index) {
                        <g>
                            <g id="plate-{{ groupInfo.groupPosition }}-{{ plate.plateIndex }}-{{ pieceIndex }}"
                               (click)="square.temporary ? onTemporaryPressurePlateClick(groupInfo.groupPosition, plate.plateIndex, pieceIndex) : onPressurePlateClick(groupInfo.groupPosition, plate.plateIndex, pieceIndex)">
                                <rect id="plate-square-{{ groupInfo.groupPosition }}-{{ plate.plateIndex }}-{{ pieceIndex }}"
                                      class="base"
                                      [ngClass]="square.squareClasses"
                                      [attr.x]="SPACE_SIZE * square.coord.x"
                                      [attr.y]="SPACE_SIZE * square.coord.y"
                                      [attr.width]="SPACE_SIZE"
                                      [attr.height]="SPACE_SIZE"
                                      [attr.rx]="0.2 * SPACE_SIZE"
                                      [attr.ry]="0.2 * SPACE_SIZE"/>
                                @if (square.hasPiece) {
                                    <circle id="plate-piece-{{ groupInfo.groupPosition }}-{{ plate.plateIndex }}-{{ pieceIndex }}"
                                            class="base"
                                            [ngClass]="square.pieceClasses"
                                            [attr.r]="PIECE_RADIUS"
                                            [attr.cx]="(SPACE_SIZE * square.coord.x) + (SPACE_SIZE / 2)"
                                            [attr.cy]="(SPACE_SIZE * square.coord.y) + (SPACE_SIZE / 2)"/>
                                }
                            </g>
                        </g>
                    }
                </g>
            }
        </g>
    }

    @if (selectedCoord.isPresent()) {
        <rect id="selection-{{ selectedCoord.get().x }}-{{ selectedCoord.get().y }}"
              class="base no-fill selected-stroke"
              [attr.x]="SPACE_SIZE * selectedCoord.get().x"
              [attr.y]="SPACE_SIZE * selectedCoord.get().y"
              [attr.width]="SPACE_SIZE"
              [attr.height]="SPACE_SIZE"/>
    }
</svg>
